/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  LinearProgress,
  FormControl,
  Autocomplete,
  Collapse,
  Snackbar,
  Alert,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  FormLabel,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Chip
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Label } from 'reactstrap';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import 'jspdf-autotable';
import './UserPrivilegesReports.css';
import moment from 'moment';
import { ReactComponent as MastersIcon } from '../media/filter.svg';
import axios from '../axiosConfig';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '800',
  // textAlign: 'center',
  backgroundColor: '#219C90',
  padding: 'none',
  whiteSpace: 'nowrap',
  width: 75
});

// Header Table Style
const HeaderStickyTableCell = styled(TableCell)({
  position: 'sticky',
  left: 0,
  zIndex: 1,
  background: '#219C90',
  color: 'white',
  fontWeight: '800',
  whiteSpace: 'nowrap',
  width: 64
});

const HeaderStickyDateCell = styled(HeaderStickyTableCell)({
  left: 64,
  width: 111
});

const HeaderStickyLineCell = styled(HeaderStickyTableCell)({
  left: 175,
  width: 77
});

const HeaderStickyStyleCell = styled(HeaderStickyTableCell)({
  left: 252,
  width: 192
});

const HeaderStickyOperationCell = styled(HeaderStickyTableCell)({
  left: 252, // 444
  width: 197
});

const HeaderStickyOperatorCell = styled(HeaderStickyTableCell)({
  left: 449, // 641
  width: 165
});

const HeaderStickyTargetCell = styled(HeaderStickyTableCell)({
  left: 614, // 806
  width: 112
});

// Body Table Style
const StyledStickyTableCell = styled(TableCell)({
  position: 'sticky',
  left: 0,
  zIndex: 1,
  background: 'white',
  whiteSpace: 'nowrap',
  width: 64
});

const StyledStickyDateCell = styled(StyledStickyTableCell)({
  left: 64,
  width: 111
});

const StyledStickyLineCell = styled(StyledStickyTableCell)({
  left: 175,
  width: 77
});

const StyledStickyStyleCell = styled(StyledStickyTableCell)({
  left: 252,
  width: 192
});

const StyledStickyOperationCell = styled(StyledStickyTableCell)({
  left: 252, // 444
  width: 197
});

const StyledStickyOperatorCell = styled(StyledStickyTableCell)({
  left: 449, // 641
  width: 165
});

const StyledStickyTargetCell = styled(StyledStickyTableCell)({
  left: 614, // 806
  width: 112
});




// Header EffTable Style
const HeaderEffStickyTableCell = styled(TableCell)({
  position: 'sticky',
  left: 0,
  zIndex: 1,
  background: '#219C90',
  color: 'white',
  fontWeight: '800',
  whiteSpace: 'nowrap',
  width: 64
});

const HeaderEffStickyDateCell = styled(HeaderEffStickyTableCell)({
  left: 64,
  width: 111
});

const HeaderEffStickyLineCell = styled(HeaderEffStickyTableCell)({
  left: 171,
  width: 77
});

const HeaderEffStickyStyleCell = styled(HeaderEffStickyTableCell)({
  left: 252,
  width: 192
});

const HeaderEffStickyOperationCell = styled(HeaderEffStickyTableCell)({
  left: 248, // 444
  width: 197
});

const HeaderEffStickyOperatorCell = styled(HeaderEffStickyTableCell)({
  left: 422, // 641
  width: 165
});

const HeaderEffStickyTargetCell = styled(HeaderEffStickyTableCell)({
  left: 589, // 806
  width: 112
});

// Body Table Style
const StyledEffStickyTableCell = styled(TableCell)({
  position: 'sticky',
  left: 0,
  zIndex: 1,
  background: 'white',
  whiteSpace: 'nowrap',
  width: 64
});

const StyledEffStickyDateCell = styled(StyledEffStickyTableCell)({
  left: 64,
  width: 111
});

const StyledEffStickyLineCell = styled(StyledEffStickyTableCell)({
  left: 171,
  width: 77
});

const StyledEffStickyStyleCell = styled(StyledEffStickyTableCell)({
  left: 252,
  width: 192
});

const StyledEffStickyOperationCell = styled(StyledEffStickyTableCell)({
  left: 248, // 444
  width: 197
});

const StyledEffStickyOperatorCell = styled(StyledEffStickyTableCell)({
  left: 422, // 641
  width: 165
});

const StyledEffStickyTargetCell = styled(StyledEffStickyTableCell)({
  left: 589, // 806
  width: 112
});



const SwitchContainer = ({ children }) => (
  <Stack direction="row" justifyContent="start" alignItems="center" spacing={1}>
    {children}
  </Stack>
);

// Set the initial state for fromDate and toDate
const formatDateToinitialValues = (date) => {
  if (!date) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
// Get the current date and 30 days before the current date
const currentDate = new Date();
const fromDateOnCurrentMonth = new Date(currentDate);
fromDateOnCurrentMonth.setDate(1);
// Convert fromDate and toDate objects to formatted date strings
const initialFromDate = formatDateToinitialValues(fromDateOnCurrentMonth);
const initialToDate = formatDateToinitialValues(currentDate);

const DailyProductionHourlyReport = () => {
  // eslint-disable-next-line no-restricted-globals
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  // At the beginning of the component
  const theme = useTheme();
  const fullScreens = useMediaQuery(theme.breakpoints.down('md'));
  const [fromDate, setfromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);
  const [styleData, setstyleData] = useState([]);
  const [styleSelected, setStyleSelected] = useState({
    Srhid: '0',
    StyleDescription: 'Select Style',
    StyleNumber: '',
    Line_Name: '',
  });
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = useState({
    Unit_Id: '0',
    Unit_Name: 'All',
  });
  const [lineData, setLineData] = useState([]);
  const [lineSelected, setLineSelected] = useState({
    Line_id: '0',
    Line_Name: 'All',
  });
  const [OperationData, setOperationData] = useState([]);
  const [opSelected, setOpSelected] = useState({
    OperationId: '0',
    OperationName: 'All',
  });
  const [OperatorsData, setOperatorsData] = useState([]);
  const [operatorSelected, setOperatorSelected] = useState({
    UserAccessID: '0',
    UserName: 'All',
  });
  const [reportType, setReportType] = useState('DateWise');
  const [reportData, setreportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showEff, setShowEff] = useState(false);
  const [showOverAll, setShowOverAll] = useState(false);

  const [comparisonOperator, setComparisonOperator] = useState(0);
  const [comparisonValue, setComparisonValue] = useState('');
  const [efficiencyData, setEfficiencyData] = useState([]);
const [report,setReport]= useState('')
  const groupedPaymentsByName = {};

  const totals = filteredData.reduce(
    (acc, enq) => {
      acc.DayTarget += Number(enq.DayTarget || 0);
      acc.Targeted += Number(enq.Targeted || 0);
      acc.OperatorCount += Number(enq.OperatorCount || 0);
      acc.HelperCount += Number(enq.HelperCount || 0);
      acc.C_operator += Number(enq.C_operator || 0);
      acc.C_helper += Number(enq.C_helper || 0);
      for (let i = 1; i <= 12; i += 1) {
        const k = `H${i}`;
        acc[k] = (acc[k] || 0) + Number(enq[k] || 0);
      }
      acc.EXPECTED += Number(enq.EXPECTED || 0);
      acc.TOTAL += Number(enq.TOTAL || 0);
      acc.StyleProducedTillDate += Number(enq.StyleProducedTillDate || 0);
      return acc;
    },
    { DayTarget: 0, Targeted: 0, EXPECTED: 0, TOTAL: 0, StyleProducedTillDate: 0, OperatorCount: 0, HelperCount: 0 , C_operator: 0, C_helper: 0 }
  );

  const achievedSum = filteredData.reduce((s, enq) => {
    return (
      s +
      (Number(enq.H1 || 0) + Number(enq.H2 || 0) + Number(enq.H3 || 0) + Number(enq.H4 || 0) + Number(enq.H5 || 0) + Number(enq.H6 || 0) + Number(enq.H7 || 0) + Number(enq.H8 || 0) + Number(enq.H9 || 0) + Number(enq.H10 || 0) + Number(enq.H11 || 0) + Number(enq.H12 || 0))
    );
  }, 0);

  const resetFilters = () => {
    setfromDate(initialFromDate);
    setToDate(initialToDate);
    setStyleSelected({
      Srhid: '0',
      StyleDescription: 'Select Style',
      StyleNumber: '',
    Line_Name: '',
    });
    setUnitSelected({ Unit_Id: '0', Unit_Name: 'All' });
    setLineSelected({
      Line_id: '0',
      Line_Name: 'All',
    });
    setOpSelected({
      OperationId: '0',
      OperationName: 'All',
    });
    setOperatorSelected({
      UserAccessID: '0',
      UserName: 'All',
    });
    setFilteredData([]);
    // setReportType('DateWise');
    setComparisonOperator(0);
    setComparisonValue('');
    setShowEff(false)
    setShowOverAll(false)
  };

  // other states
  const [openLoader, setOpenLoader] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showNoResultsSnackbar, setShowNoResultsSnackbar] = useState(false);
  const [noResultsMessage, setNoResultsMessage] = useState('');
  const [expanded, setExpanded] = React.useState(true);
  // pagination
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1));
  const [efficiencyDetailsOpen, setEfficiencyDetailsOpen] = useState(false);

  const[overall,setOverall]=useState(false)

  // API Integration
  useEffect(() => {
    GetAllActiveProductionUnits();
    GetAllActiveLineMstData(sessionStorage.getItem('factoryID'));
    GetAllActiveOperationMst();
    GetAllOperators();
    getAllStyles();
    formatDateToinitialValues();
  }, []);

  useEffect(() => {
  if (reportType === "StyleWise" || reportType === "Style") {
    setStyleSelected({
      StyleDescription: "All",
      Srhid: "0",
      StyleNumber: "",
      Line_Name: "",
    });
  }
}, [reportType]);

  const handleEfficiencyDetailsClose = () => {
    setEfficiencyDetailsOpen(false);
  };

  const handleEfficiencyDetailsOpen = () => {
    setEfficiencyDetailsOpen(true);
  };

  // get all Style data
  const getAllStyles = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/getAllDailyStyles', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setstyleData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

   const getStyles = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/getStyles', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setstyleData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
 
  const handleStyleFilter = (overall)=>{
    setOpenLoader(true);
    console.log(overall,'overall');
    
     if(overall)
      { 
        getStyles() 
      }
     else 
      { 
      getAllStyles() 
    }
      setOpenLoader(false);
  }
  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all line data
  const GetAllActiveLineMstData = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveLineMstData/${sessionStorage.getItem('UserID')}/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Operation Request
  const GetAllActiveOperationMst = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperationData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Operators Request
  const GetAllOperators = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllOperators', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperatorsData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  reportData.forEach((payment) => {
    const fullName = `${payment.FirstName} ${payment.LastName}`;
    if (!groupedPaymentsByName[fullName]) {
      groupedPaymentsByName[fullName] = [];
    }
    groupedPaymentsByName[fullName].push(payment);
  });

  const applyFilters = async () => {
   
    if ((Number(styleSelected.Srhid) === 0 || styleSelected.Srhid === '') && reportType !== 'StyleWise' && reportType !== 'Style') {
      setShowNoResultsSnackbar(true);
      setNoResultsMessage('Please Select Style')
    } else {
      setOpenLoader(true);
      try {
        console.log('API calling...');
        console.log('Selected Report Type:', reportType);
        const OBid = overall ? styleSelected.Srhid : 0 ;
        const TSid = overall ? 0 : styleSelected.Srhid ;
         let res;
        if(reportType === 'StyleWise' || reportType === 'Style'){
               res = await axios.instance.get(
          `/getDailyHourlyProductionStyleWise/${TSid}/${unitSelected.Unit_Id}/${lineSelected.Line_id}/${operatorSelected.UserAccessID}/${opSelected.OperationId}/${fromDate}/${toDate}/${'DailyProddate'}/${comparisonOperator}/${comparisonValue === '' ? 0 : comparisonValue}/${showOverAll ? 'Y' : 'N'}/${OBid}`,
          {
            headers: { Authorization: tokent, 'Content-Type': 'application/json' },
          }
        );
        }
        else
          {
        res = await axios.instance.get(
          `/getDailyHourlyProduction/${TSid}/${unitSelected.Unit_Id}/${lineSelected.Line_id}/${operatorSelected.UserAccessID}/${opSelected.OperationId}/${fromDate}/${toDate}/${reportType === 'DateWise' ? 'DailyProddate' : reportType === 'OperatorWise' ? 'UserCode' : 'OperationName'}/${comparisonOperator}/${comparisonValue === '' ? 0 : comparisonValue}/${showOverAll ? 'Y' : 'N'}/${OBid}`,
          {
            headers: { Authorization: tokent, 'Content-Type': 'application/json' },
          }
        );
      }
      console.log(res.data,'res.data')
        setFilteredData(res.data);
        setPage(0);
        setOpenLoader(false);
        // setExpanded(false);
        if (res.data.length === 0) {
          setShowNoResultsSnackbar(true);
          setNoResultsMessage('No results found for the applied filters.')
        } else {
          GetHourwiseeff()
          setShowNoResultsSnackbar(false);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  const downloadPDF = async () => {
    if ((Number(styleSelected.Srhid) === 0 || styleSelected.Srhid === '') && reportType !== 'StyleWise' && reportType !== 'Style') {
      setShowNoResultsSnackbar(true);
      setNoResultsMessage('Please Select Style')
    } else {
      setOpenLoader(true);
      try {
        const OBid = overall ? styleSelected.Srhid : 0 ;
        const TSid = overall ? 0 : styleSelected.Srhid ;
     let res
         if(reportType === 'StyleWise' || reportType === 'Style'){
           res = await axios.instance.get(
               `/GetdailyhourprodctionStyleWisepdf/${TSid}/${unitSelected.Unit_Id}/${lineSelected.Line_id}/${operatorSelected.UserAccessID}/${opSelected.OperationId}/${fromDate}/${toDate}/${'DailyProddate'}/${comparisonOperator}/${comparisonValue === '' ? 0 : comparisonValue}/${showOverAll ? 'Y' : 'N'}/${OBid}/${reportType === 'Style' ? 'withoutWIP' : 'WIP'}`,
          {
            responseType: 'blob', // Important: tells axios to handle the response as binary data
            headers: { Authorization: tokent, 'Content-Type': 'application/json' },
          }
        );
         } else 
          {
         res = await axios.instance.get(
          `/Getdailyhourprodctionpdf/${TSid}/${unitSelected.Unit_Id}/${lineSelected.Line_id}/${operatorSelected.UserAccessID}/${opSelected.OperationId}/${fromDate}/${toDate}/${reportType === 'DateWise' ? 'DailyProddate' : reportType === 'OperatorWise' ? 'UserCode' : 'OperationName'}/${comparisonOperator}/${comparisonValue === '' ? 0 : comparisonValue}/${showOverAll ? 'Y' : 'N'}/${OBid}`,
          {
            responseType: 'blob', // Important: tells axios to handle the response as binary data
            headers: { Authorization: tokent, 'Content-Type': 'application/json' },
          }
        );
      }

        // Create a link element, use it to download the file
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'DailyProduction.pdf'); // Specify the filename
        document.body.appendChild(link);
        link.click();

        // Clean up and remove the link
        document.body.removeChild(link);

        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setOpenLoader(false);
      }
    }
  };

  // Get Hourwise efficiency
  const GetHourwiseeff = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/getDailyHourWiseEff', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setEfficiencyData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleCloseSnackbar = () => {
    setShowNoResultsSnackbar(false);
  };

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const handleComparisonOperatorChange = (event) => {
    setComparisonOperator(event.target.value);
  };

  const handleComparisonValueChange = (event) => {
    const value = event.target.value;
    if (value === '' || (value >= 0 && value <= 100)) {
      setComparisonValue(value);
    }
  };

  const columnWidths = {
    sno: 64.25,
    dailyProdDate: 110.58,
    line: 72.61,
    style: 69.31,
    operation: 196.91,
    operator: 164.48,
    target: 111.55,
    // Add other columns as needed
  };

  // const calculateLeftPosition = (column) => {
  //   console.log(column,'column')
  //   const keys = Object.keys(columnWidths);
  //   console.log(keys,'keys')
  //   return keys.reduce((left, key) => {
  //     if (key === column) return left;
  //     return left + columnWidths[key];
  //   }, 0);
  // };

  const calculateLeftPosition = (column) => {
    const keys = Object.keys(columnWidths);
    const leftPosition = keys.reduce((left, key) => {
      if (key === column) return left;
      return left + columnWidths[key];
    }, 0);
    return Math.round(leftPosition * 100) / 100;  // Round to 2 decimal places
  };


  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2, p: 1 }} elevation={3}>
        <Snackbar
          style={{ marginTop: '45px' }}
          open={showNoResultsSnackbar}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="info" variant="filled" sx={{ width: '100%' }}>
            {noResultsMessage}
          </Alert>
        </Snackbar>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2} mb={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #134e5e, #71b280)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Daily Production Hourly Report
            </Typography>
          </Typography>
        </Grid>

        {/* filters */}
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="white">
                  <MastersIcon style={{ color: 'white', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#36BA98',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Stack direction={'column'} justifyContent={'space-between'} spacing={2} my={1}>
                <Stack direction={{ sm: 'row', xs: 'column' }} spacing={1}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item xs={12}>
                      <Stack direction={'row'} justifyContent={'end'} spacing={2}>
                        <FormControl size="small" component="fieldset">
                          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2}>
                            <FormLabel component="legend">Show Results By</FormLabel>
                            <RadioGroup
                              row
                              value={reportType}
                              onChange={(e) => {
                                setReportType(e.target.value);
                              }}
                            >
                              <FormControlLabel
                                value="DateWise"
                                control={<Radio />}
                                onClick={() => resetFilters()}
                                label="Date"
                              />
                              <FormControlLabel
                                value="OperatorWise"
                                control={<Radio />}
                                onClick={() => resetFilters()}
                                label="Operators"
                              />
                              <FormControlLabel
                                value="OperationWise"
                                control={<Radio />}
                                onClick={() => resetFilters()}
                                label="Operation"
                              />
                                  <FormControlLabel
                                value="StyleWise"
                                control={<Radio />}
                                onClick={() => resetFilters()}
                                label="Style Wise-WIP"
                              />
                              <FormControlLabel
                                value="Style"
                                control={<Radio />}
                                onClick={() => resetFilters()}
                                label="Style Wise"
                              />
                            </RadioGroup>
                          </Stack>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="From Date"
                        type="date"
                        value={fromDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setfromDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="To Date"
                        type="date"
                        value={toDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setToDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControl size="small" fullWidth component="fieldset" 
                      required={reportType !== 'StyleWise' && reportType !== 'Style'}
                      >
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={reportType === 'StyleWise' || reportType === 'Style'
                             ? [{ StyleDescription: 'All', Srhid: '0', StyleNumber: '', Line_Name: '' }, ...styleData]
                             : styleData}
                          getOptionLabel={
                            (obj) => obj.Srhid !== '0' && obj.Line_Name !== ''
                            ? `${obj.StyleDescription} - ${obj.StyleNumber} - ${obj.Line_Name}` 
                            : `${obj.StyleDescription} - ${obj.StyleNumber}`}
                          isOptionEqualToValue={(option, value) => option.StyleDescription === value.StyleDescription}
                          renderInput={(params) => <TextField {...params} label="Style" 
                           required={reportType !== 'StyleWise' && reportType !== 'Style'}
                           />}
                          value={styleSelected}
                          onChange={(e, newValue) => {
                            setStyleSelected(newValue);
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                    {(reportType !== 'StyleWise' && reportType !== 'Style') && (
                      <Grid item xs={12} md={2}>
                        <SwitchContainer>
                                <input
                                  id={`manufacturerb`}
                                  className="checkboxfilter"
                                  type="checkbox"
                                  checked={overall}
                                  onClick={(e) => {
                                   // const newValue = !overall;
                                     setStyleSelected({
                                              Srhid: '0',
                                              StyleDescription: 'Select Style',
                                              StyleNumber: '',
                                              Line_Name: '',
                                            });
                                   handleStyleFilter(!overall);
                                   setOverall(!overall);
                                  }}
                                />{' '}
                                <Label
                                  htmlFor='manufacturerb'
                                  className=" font_stylechecklable text-dark-emphasis"
                                  style={{ color: '#468585' }}
                                >
                                  OverAll
                                </Label>
                              </SwitchContainer>
                      </Grid>)}
                    <Grid item xs={12} md={3}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={[{ Unit_Name: 'All', Unit_Id: '0' }, ...unitData]}
                          getOptionLabel={(obj) => obj.Unit_Name}
                          isOptionEqualToValue={(option, value) => option.Unit_Name === value.Unit_Name}
                          renderInput={(params) => <TextField {...params} label="Factory" />}
                          value={unitSelected}
                          onChange={(e, newValue) => {
                            setUnitSelected(newValue);
                            GetAllActiveLineMstData(newValue.Unit_Id)
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={[{ Line_Name: 'All', Line_id: '0' }, ...lineData]}
                          getOptionLabel={(obj) => obj.Line_Name}
                          isOptionEqualToValue={(option, value) => option.Line_Name === value.Line_Name}
                          renderInput={(params) => <TextField {...params} label="Batch/Line" />}
                          value={lineSelected}
                          onChange={(e, newValue) => {
                            setLineSelected(newValue);
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={[{ OperationName: 'All', OperationId: '0' }, ...OperationData]}
                          getOptionLabel={(obj) => obj.OperationName}
                          isOptionEqualToValue={(option, value) => option.OperationId === value.OperationId}
                          renderInput={(params) => <TextField {...params} label="Operations" />}
                          value={opSelected}
                          onChange={(e, newValue) => {
                            setOpSelected(newValue);
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          disabled={reportType === 'OperationWise'}
                          options={[{ UserName: 'All', UserAccessID: '0' }, ...OperatorsData]}
                          getOptionLabel={(obj) => obj.UserName}
                          isOptionEqualToValue={(option, value) => option.UserAccessID === value.UserAccessID}
                          renderInput={(params) => <TextField {...params} label="Operators" />}
                          value={operatorSelected}
                          onChange={(e, newValue) => {
                            setOperatorSelected(newValue);
                          }}
                          clearText="Clear"
                          disableClearable
                        />
                      </FormControl>
                    </Grid>
                    {reportType !== 'OperationWise' ? (
                      <>
                        <Grid
                          item
                          xs={comparisonOperator === 0 ? 12 : 8}
                          lg={comparisonOperator === 0 ? 3 : 2}
                          md={comparisonOperator === 0 ? 12 : 6}
                        >
                          <FormControl size="small" fullWidth>
                            <InputLabel id="comparison-operator-label">Comparison</InputLabel>
                            <Select
                              labelId="comparison-operator-label"
                              value={comparisonOperator}
                              onChange={handleComparisonOperatorChange}
                              label="Comparison"
                            >
                              <MenuItem value="0">{'No Condition'}</MenuItem>
                              <MenuItem value="1">{'Greater Than (>)'}</MenuItem>
                              <MenuItem value="2">{'Less Than (<)'}</MenuItem>
                              <MenuItem value="3">{'Greater Than or Equal (>=)'}</MenuItem>
                              <MenuItem value="4">{'Less Than or Equal (<=)'}</MenuItem>
                              <MenuItem value="5">{'Equal To (=)'}</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        {comparisonOperator !== 0 && (
                          <Grid item xs={4} lg={1} md={6}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Value%"
                              type="number"
                              inputProps={{ max: 100, min: 0 }}
                              value={comparisonValue}
                              onChange={handleComparisonValueChange}
                            />
                          </Grid>
                        )}
                        <Grid item xs={12} lg={3} md={6}>
                          <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'end'} alignItems={'center'}>
                            <Grid item xs={12}>
                              <SwitchContainer>
                                <input
                                  id={`manufacturerbrand`}
                                  className="checkboxfilter"
                                  type="checkbox"
                                  checked={showEff}
                                  onClick={(e) => {
                                    const newValue = !showEff;
                                    setShowEff(newValue);
                                  }}
                                />{' '}
                                <Label
                                  htmlFor="manufacturerbrand"
                                  className=" font_stylechecklable text-dark-emphasis"
                                  style={{ color: '#468585' }}
                                >
                                  Show Efficiency
                                </Label>
                              </SwitchContainer>
                            </Grid>
                          </Stack>
                        </Grid>
                      </>)
                      :
                      (<Grid item xs={12} lg={6} md={6}>
                        <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'end'} alignItems={'center'}>
                          <Grid item xs={12}>
                            <SwitchContainer>
                              <input
                                id={`manufacturerbrand`}
                                className="checkboxfilter"
                                type="checkbox"
                                checked={showOverAll}
                                onClick={(e) => {
                                  const newValue = !showOverAll;
                                  setShowOverAll(newValue);
                                }}
                              />{' '}
                              <Label
                                htmlFor="manufacturerbrand"
                                className=" font_stylechecklable text-dark-emphasis"
                                style={{ color: '#468585' }}
                              >
                                Show OverAll
                              </Label>
                            </SwitchContainer>
                          </Grid>
                        </Stack>
                      </Grid>)}

                    <Grid item xs={12} lg={6} md={6}>
                      <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'end'}>
                        <Stack direction={'row'} spacing={1}>
                          <Button
                            variant="outlined"
                            startIcon={<PictureAsPdfIcon />}
                            onClick={downloadPDF}
                            color="error"
                            aria-label="Download as PDF"
                          >
                            PDF
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => applyFilters()}
                            startIcon={<FilterAltIcon />}
                            sx={{ boxShadow: 0 }}
                          >
                            Apply Filters
                          </Button>
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={resetFilters}
                            startIcon={<LockResetIcon />}
                            sx={{ boxShadow: 0 }}
                          >
                            reset
                          </Button>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Stack>

        <Collapse in={filteredData.length > 0}>
          <>
            <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'space-between'} alignItems={'center'} mb={2}>
              {filteredData.length > 0 &&
                <>
                  <Chip
                    label={
                      <span>
                        <span>Style:</span> <span style={{ fontWeight: 600 }}>{styleSelected.StyleDescription}</span>
                      </span>
                    }
                    variant="contained"
                    color="secondary"
                  />

                  <Button
                    variant="outlined"
                    startIcon={<AccessTimeIcon />}
                    onClick={handleEfficiencyDetailsOpen}
                    color="info"
                    aria-label="Hourwise Efficiency"
                  >
                    Hourwise Efficiency
                  </Button>
                </>
              }
            </Stack>
            { ((reportType === 'StyleWise' || reportType === 'Style') && !showEff) && (
                  <>
                <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ padding: 'none' }}>
                        <StyledTableCell>S.No</StyledTableCell>
                         {/* <StyledTableCell align="center">Date</StyledTableCell> */}
                        <StyledTableCell align="center">Line</StyledTableCell>
                   
                      {reportType === 'StyleWise' && <StyledTableCell align="center">Supervisor</StyledTableCell>}
                       {reportType === 'StyleWise' && <StyledTableCell align="center">Opert.</StyledTableCell>}
                       {reportType === 'StyleWise' && <StyledTableCell align="center">Helper</StyledTableCell>}
                       {reportType === 'StyleWise' &&  <StyledTableCell align="center">No.Days</StyledTableCell>}
                     
                       <StyledTableCell align="left">Style</StyledTableCell> 
                       {reportType === 'StyleWise' &&  <StyledTableCell align="left">WIP</StyledTableCell> }
                         <StyledTableCell align="center">D-Target</StyledTableCell>

                        <StyledTableCell align="center">H-Target</StyledTableCell>
                        <StyledTableCell align="center">H1</StyledTableCell>
                        <StyledTableCell align="center">H2</StyledTableCell>
                        <StyledTableCell align="center">H3</StyledTableCell>
                        <StyledTableCell align="center">H4</StyledTableCell>
                        <StyledTableCell align="center">H5</StyledTableCell>
                        <StyledTableCell align="center">H6</StyledTableCell>
                        <StyledTableCell align="center">H7</StyledTableCell>
                        <StyledTableCell align="center">H8</StyledTableCell>
                        {/* <StyledTableCell align="center">H9</StyledTableCell>
                        <StyledTableCell align="center">H10</StyledTableCell>
                        <StyledTableCell align="center">H11</StyledTableCell>
                        <StyledTableCell align="center">H12</StyledTableCell> */}
                         <StyledTableCell align="center">Other</StyledTableCell>

                        <StyledTableCell align="center">Achv.Total</StyledTableCell>
                        {reportType === 'StyleWise' &&  <StyledTableCell align="center">Excess/Shortage</StyledTableCell>}

                     <StyledTableCell align="center">Cum.Total</StyledTableCell> 

                        {/* <StyledTableCell align="center">Expected</StyledTableCell>
                        <StyledTableCell align="center">Actual</StyledTableCell> */}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {(rowsPerPage > 0
                        ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : filteredData
                      ).map((enq, index) => (
                        <TableRow key={index} hover>
                          {!showEff && (
                            <>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {page * rowsPerPage + index+1}
                              </TableCell>
                              {/* {!showOverAll &&
                                <TableCell
                                  align="left"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                                  {enq.DailyProddate}
                                </TableCell>} */}
                              <TableCell
                                align="left"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.Line_Name}
                              </TableCell>
                              {/* <TableCell
                                  align="left"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                                  {enq.StyleDescription}
                                </TableCell> */}
                              {reportType === 'StyleWise' &&  <TableCell
                                align="left"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                 {enq.Supervisor || ''}
                              </TableCell> }
                              
                               {reportType === 'StyleWise' &&  <TableCell
                                  align="center"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                               {enq.OperatorCount ? enq.C_operator ? `${enq.OperatorCount} / ${enq.C_operator}` : enq.OperatorCount : ''}
                                </TableCell>}

                                {reportType === 'StyleWise' &&  <TableCell
                                  align="center"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                               {enq.HelperCount ? enq.C_helper ? `${enq.HelperCount} / ${enq.C_helper}` : enq.HelperCount : ''}
                                </TableCell>}
                                {reportType === 'StyleWise' &&   <TableCell
                                  align="center"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                               {enq.ProductionDays}
                                </TableCell>}
                                 <TableCell
                                  align="left"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                               {enq.StyleDescription}-{enq.StyleNumber}
                                </TableCell>
                               {reportType === 'StyleWise' &&   <TableCell
                                  align="center"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                               {Number(enq.WIP) === 0
                                  ? 0
                                  : Number(enq.WIP) -
                                    (Number(enq.H1) +
                                      Number(enq.H2) +
                                      Number(enq.H3) +
                                      Number(enq.H4) +
                                      Number(enq.H5) +
                                      Number(enq.H6) +
                                      Number(enq.H7) +
                                      Number(enq.H8) +
                                      Number(enq.H9) +
                                      Number(enq.H10) +
                                      Number(enq.H11) +
                                      Number(enq.H12))}
                                </TableCell>}
                                 <TableCell
                                  align="center"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                               {enq.DayTarget}
                                </TableCell>

                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.Targeted}
                              </TableCell>

                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                              >
                                {enq.H1 === 0 ? '' : enq.H1}
                              </TableCell>

                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                              >
                                {enq.H2 === 0 ? '' : enq.H2}
                              </TableCell>

                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H3 === 0 ? '' : enq.H3}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H4 === 0 ? '' : enq.H4}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H5 === 0 ? '' : enq.H5}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H6 === 0 ? '' : enq.H6}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H7 === 0 ? '' : enq.H7}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H8 === 0 ? '' : enq.H8}
                              </TableCell>
                              {/* <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H9 === 0 ? '' : enq.H9}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H10 === 0 ? '' : enq.H10}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H11 === 0 ? '' : enq.H11}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H12 === 0 ? '' : enq.H12}
                              </TableCell> */}
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H9+enq.H10+enq.H11+enq.H12 || ''}
                              </TableCell>
                                <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H1+enq.H2+enq.H3+enq.H4+enq.H5+enq.H6+enq.H7+enq.H8+enq.H9+enq.H10+enq.H11+enq.H12}
                              </TableCell>
                              
                                 {reportType === 'StyleWise' &&   <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {(() => { const val = (enq.H1+enq.H2+enq.H3+enq.H4+enq.H5+enq.H6+enq.H7+enq.H8+enq.H9+enq.H10+enq.H11+enq.H12) - enq.DayTarget; return (
                                  <span style={{ color: val >= 0 ? '#2e7d32' : '#d32f2f', fontWeight: 600, display: 'inline-flex', alignItems: 'center' }}>
                                    {val >= 0 ? <ArrowUpwardIcon sx={{ fontSize: 14, mr: 0.3 }} /> : <ArrowDownwardIcon sx={{ fontSize: 14, mr: 0.3 }} />}
                                    {val}
                                  </span>
                                ); })()}
                              </TableCell>}

                                    <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                 {enq.StyleProducedTillDate}
                              </TableCell>

                              {/* <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.EXPECTED}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                <span style={{ fontWeight: 600 }}>{enq.TOTAL} </span><span style={{ color: '#4eb72d', fontSize: 'smaller' }}>({enq.ACTUAL}%)</span>
                              </TableCell> */}
                            </>
                          )}
                        </TableRow>
                      ))}

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell colSpan={reportType === 'StyleWise' ? 3 : 2} align="center" sx={{fontWeight: 'bold'}}>Totals</TableCell>
                        {reportType === 'StyleWise' && <TableCell align="center" sx={{fontWeight: 'bold'}}>{(totals.OperatorCount)+(totals.C_operator)}</TableCell>}
                        {reportType === 'StyleWise' && <TableCell align="center" sx={{fontWeight: 'bold'}}>{(totals.HelperCount)+(totals.C_helper)}</TableCell>}
                        {reportType === 'StyleWise' && <TableCell />}
                        <TableCell />
                        {reportType === 'StyleWise' && <TableCell />}
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.DayTarget}</TableCell>
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.Targeted}</TableCell>
                        {[1,2,3,4,5,6,7,8].map((h) => (
                          <TableCell key={h} align="center" sx={{fontWeight: 'bold'}}>
                            {totals[`H${h}`] || 0}
                          </TableCell>
                        ))}
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>
                          {Number(totals.H9 || 0) + Number(totals.H10 || 0) + Number(totals.H11 || 0) + Number(totals.H12 || 0)}
                        </TableCell>
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>{achievedSum}</TableCell>
                        {reportType === 'StyleWise' && <TableCell align="center" sx={{fontWeight: 'bold'}}>{(() => { const val = achievedSum - totals.DayTarget; return (
                          <span style={{ color: val >= 0 ? '#2e7d32' : '#d32f2f', fontWeight: 600, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                            {val >= 0 ? <ArrowUpwardIcon sx={{ fontSize: 14, mr: 0.3 }} /> : <ArrowDownwardIcon sx={{ fontSize: 14, mr: 0.3 }} />}
                            {val}
                          </span>
                        ); })()}</TableCell>}
                         <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.StyleProducedTillDate}</TableCell>
                      </TableRow>

                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )
          
          }

            {((reportType === 'StyleWise' || reportType === 'Style') && showEff) && (
              <>
                <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ padding: 'none' }}>
                        <StyledTableCell>S.No</StyledTableCell>
                        <StyledTableCell align="center">Date</StyledTableCell>
                        <StyledTableCell align="center">Line</StyledTableCell>
                        {reportType === 'StyleWise' &&  <StyledTableCell align="center">Line Supervisor</StyledTableCell>}
                        {reportType === 'StyleWise' && <StyledTableCell align="center">Operators</StyledTableCell>}
                         {reportType === 'StyleWise' &&<StyledTableCell align="center">Helpers</StyledTableCell>}
                        {reportType === 'StyleWise' &&  <StyledTableCell align="center">No Of Days</StyledTableCell>}
                        <StyledTableCell align="left">Style</StyledTableCell>
                         {reportType === 'StyleWise' && <StyledTableCell align="left">WIP</StyledTableCell>}
                        <StyledTableCell align="center">Day Target</StyledTableCell>
                        <StyledTableCell align="center">Hour Target</StyledTableCell>
                        <StyledTableCell align="center">H1</StyledTableCell>
                        <StyledTableCell align="center">H2</StyledTableCell>
                        <StyledTableCell align="center">H3</StyledTableCell>
                        <StyledTableCell align="center">H4</StyledTableCell>
                        <StyledTableCell align="center">H5</StyledTableCell>
                        <StyledTableCell align="center">H6</StyledTableCell>
                        <StyledTableCell align="center">H7</StyledTableCell>
                        <StyledTableCell align="center">H8</StyledTableCell>
                        <StyledTableCell align="center">H9</StyledTableCell>
                        <StyledTableCell align="center">H10</StyledTableCell>
                        <StyledTableCell align="center">H11</StyledTableCell>
                        <StyledTableCell align="center">H12</StyledTableCell>
                        <StyledTableCell align="center">Achieved Total</StyledTableCell>
                        {reportType === 'StyleWise' &&  <StyledTableCell align="center">Excess/Shortage</StyledTableCell>}
                        <StyledTableCell align="center">Cumulative Total</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(rowsPerPage > 0
                        ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : filteredData
                      ).map((enq, index) => (
                        <TableRow key={index} hover>
                          <TableCell align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                           {page * rowsPerPage + index+1}
                          </TableCell>
                          {!showOverAll &&
                            <TableCell align="left" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                              {enq.DailyProddate}
                            </TableCell>}
                          <TableCell align="left" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {enq.Line_Name}
                          </TableCell>
                          {reportType === 'StyleWise' &&  <TableCell align="left" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {enq.Supervisor || ''}
                          </TableCell>}
                          {reportType === 'StyleWise' && <TableCell align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {enq.OperatorCount}
                          </TableCell>}
                          {reportType === 'StyleWise' && <TableCell align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {enq.HelperCount}
                          </TableCell>}
                           {reportType === 'StyleWise' && <TableCell align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {enq.ProductionDays}
                          </TableCell>}
                          <TableCell align="left" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {enq.StyleDescription}-{enq.StyleNumber}
                          </TableCell>
                           {reportType === 'StyleWise' && <TableCell align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {Number(enq.WIP) === 0
                                ? 0
                                : Number(enq.WIP) -
                                  (Number(enq.H1) +
                                    Number(enq.H2) +
                                    Number(enq.H3) +
                                    Number(enq.H4) +
                                    Number(enq.H5) +
                                    Number(enq.H6) +
                                    Number(enq.H7) +
                                    Number(enq.H8) +
                                    Number(enq.H9) +
                                    Number(enq.H10) +
                                    Number(enq.H11) +
                                    Number(enq.H12))}
                          </TableCell> }
                          <TableCell align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {enq.DayTarget}
                          </TableCell>
                          <TableCell align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {enq.Targeted}
                          </TableCell>
                          {[1,2,3,4,5,6,7,8,9,10,11,12].map((h) => (
                            <TableCell key={h} align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                              <span style={{ fontWeight: 600 }}>{enq[`H${h}`] === 0 ? '' : enq[`H${h}`]} </span>
                              <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                                {enq[`H${h}`] === 0 ? '' : `(${Math.round((enq[`H${h}`] / enq.Targeted) * 100)}%)`}
                              </span>
                            </TableCell>
                          ))}
                          <TableCell align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            <span style={{ fontWeight: 600 }}>
                              {enq.H1+enq.H2+enq.H3+enq.H4+enq.H5+enq.H6+enq.H7+enq.H8+enq.H9+enq.H10+enq.H11+enq.H12}
                            </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.Targeted > 0 ? ` (${Math.round(((enq.H1+enq.H2+enq.H3+enq.H4+enq.H5+enq.H6+enq.H7+enq.H8+enq.H9+enq.H10+enq.H11+enq.H12) / enq.DayTarget) * 100)}%)` : ''}
                            </span>
                          </TableCell>
                          {reportType === 'StyleWise' &&  <TableCell align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {(() => { const val = (enq.H1+enq.H2+enq.H3+enq.H4+enq.H5+enq.H6+enq.H7+enq.H8+enq.H9+enq.H10+enq.H11+enq.H12) - enq.DayTarget; return (
                              <span style={{ color: val >= 0 ? '#2e7d32' : '#d32f2f', fontWeight: 600, display: 'inline-flex', alignItems: 'center' }}>
                                {val >= 0 ? <ArrowUpwardIcon sx={{ fontSize: 14, mr: 0.3 }} /> : <ArrowDownwardIcon sx={{ fontSize: 14, mr: 0.3 }} />}
                                {val}
                              </span>
                            ); })()}
                          </TableCell> }
                           <TableCell align="center" padding="normal" sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
                            {enq.StyleProducedTillDate}
                          </TableCell>
                        </TableRow>
                      ))}
                       <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell colSpan={reportType === 'StyleWise' ? 4 : 3} align="center" sx={{fontWeight: 'bold'}}>Totals</TableCell>
                        {reportType === 'StyleWise' && <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.OperatorCount}</TableCell>}
                        {reportType === 'StyleWise' && <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.HelperCount}</TableCell>}
                        {reportType === 'StyleWise' && <TableCell />}
                        <TableCell />
                        {reportType === 'StyleWise' && <TableCell />}
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.DayTarget}</TableCell>
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.Targeted}</TableCell>
                        {[1,2,3,4,5,6,7,8,9,10,11,12].map((h) => (
                          <TableCell key={h} align="center" sx={{fontWeight: 'bold'}}>
                            {totals[`H${h}`] || 0}
                          </TableCell>
                        ))}
                      <TableCell align="center" sx={{fontWeight: 'bold'}}>{achievedSum}</TableCell>
                        {reportType === 'StyleWise' && <TableCell align="center" sx={{fontWeight: 'bold'}}>{(() => { const val = achievedSum - totals.DayTarget; return (
                          <span style={{ color: val >= 0 ? '#2e7d32' : '#d32f2f', fontWeight: 600, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                            {val >= 0 ? <ArrowUpwardIcon sx={{ fontSize: 14, mr: 0.3 }} /> : <ArrowDownwardIcon sx={{ fontSize: 14, mr: 0.3 }} />}
                            {val}
                          </span>
                        ); })()}</TableCell>}
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.StyleProducedTillDate}</TableCell>
                      </TableRow>

                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}

            {/* table  */}
            {(reportType !== 'StyleWise' && reportType !== 'Style' && !showEff) && (
              <>
                <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ padding: 'none' }}>
                        <StyledTableCell>S.No</StyledTableCell>
                        {!showOverAll && <StyledTableCell align="center">Date</StyledTableCell>}
                        <StyledTableCell align="left">Line</StyledTableCell>
                        {/* <StyledTableCell align="left">Style</StyledTableCell> */}
                        <StyledTableCell align="left">Operation</StyledTableCell>
                        {reportType !== 'OperationWise' && <StyledTableCell align="left">Operator</StyledTableCell>}
                        <StyledTableCell align="center">Hour Target</StyledTableCell>
                        <StyledTableCell align="center">H1</StyledTableCell>
                        <StyledTableCell align="center">H2</StyledTableCell>
                        <StyledTableCell align="center">H3</StyledTableCell>
                        <StyledTableCell align="center">H4</StyledTableCell>
                        <StyledTableCell align="center">H5</StyledTableCell>
                        <StyledTableCell align="center">H6</StyledTableCell>
                        <StyledTableCell align="center">H7</StyledTableCell>
                        <StyledTableCell align="center">H8</StyledTableCell>
                        <StyledTableCell align="center">H9</StyledTableCell>
                        <StyledTableCell align="center">H10</StyledTableCell>
                        <StyledTableCell align="center">H11</StyledTableCell>
                        <StyledTableCell align="center">H12</StyledTableCell>
                        <StyledTableCell align="center">Expected</StyledTableCell>
                        <StyledTableCell align="center">Actual</StyledTableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {(rowsPerPage > 0
                        ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : filteredData
                      ).map((enq, index) => (
                        <TableRow key={index} hover>
                          {!showEff && (
                            <>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.sno}
                              </TableCell>
                              {!showOverAll &&
                                <TableCell
                                  align="left"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                                  {enq.DailyProddate}
                                </TableCell>}
                              <TableCell
                                align="left"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.Line_Name}
                              </TableCell>
                              {/* <TableCell
                                  align="left"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                                  {enq.StyleDescription}
                                </TableCell> */}
                              <TableCell
                                align="left"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.OperationName}
                              </TableCell>
                              {reportType !== 'OperationWise' &&
                                <TableCell
                                  align="left"
                                  padding="normal"
                                  sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                                >
                                  {enq.OperatorName}
                                </TableCell>}
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.Targeted}
                              </TableCell>

                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                              >
                                {enq.H1 === 0 ? '' : enq.H1}
                              </TableCell>

                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                              >
                                {enq.H2 === 0 ? '' : enq.H2}
                              </TableCell>

                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H3 === 0 ? '' : enq.H3}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H4 === 0 ? '' : enq.H4}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H5 === 0 ? '' : enq.H5}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H6 === 0 ? '' : enq.H6}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H7 === 0 ? '' : enq.H7}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H8 === 0 ? '' : enq.H8}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H9 === 0 ? '' : enq.H9}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H10 === 0 ? '' : enq.H10}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H11 === 0 ? '' : enq.H11}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.H12 === 0 ? '' : enq.H12}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                {enq.EXPECTED}
                              </TableCell>
                              <TableCell
                                align="center"
                                padding="normal"
                                sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                              >
                                <span style={{ fontWeight: 600 }}>{enq.TOTAL} </span><span style={{ color: '#4eb72d', fontSize: 'smaller' }}>({enq.ACTUAL}%)</span>
                              </TableCell>
                            </>
                          )}
                        </TableRow>
                      ))}
                    
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell colSpan={reportType === 'OperationWise' ? 1 : 2} align="center" sx={{fontWeight: 'bold'}}>Totals</TableCell>
                        {/* <TableCell colSpan={2} align="center" sx={{fontWeight: 'bold'}}>Totals</TableCell> */}
                        {/* <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.OperatorCount}</TableCell>
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.HelperCount}</TableCell> */}
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.Targeted}</TableCell>
                        {[1,2,3,4,5,6,7,8,9,10,11,12].map((h) => (
                          <TableCell key={h} align="center" sx={{fontWeight: 'bold'}}>
                            {totals[`H${h}`] || 0}
                          </TableCell>
                        ))}
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>{totals.EXPECTED}</TableCell>
                        <TableCell align="center" sx={{fontWeight: 'bold'}}>
                          <span style={{ fontWeight: 600 }}>{totals.TOTAL} </span>
                          <span style={{ color: '#4eb72d', fontSize: 'smaller' }}>
                            {totals.EXPECTED > 0 ? `(${Math.round((totals.TOTAL / totals.EXPECTED) * 100)}%)` : ''}
                          </span>
                        </TableCell>
                      </TableRow>

                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}

            {(showEff && reportType !== 'StyleWise' && reportType !== 'Style') && (
              <>
                <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ padding: 'none' }}>
                        <StyledTableCell>S.No</StyledTableCell>
                        <StyledTableCell align="center">Date</StyledTableCell>
                        <StyledTableCell align="left">Line</StyledTableCell>
                        {/* <StyledTableCell align="left">Style</StyledTableCell> */}
                        <StyledTableCell align="left">Operation</StyledTableCell>
                        <StyledTableCell align="left">Operator</StyledTableCell>
                        <StyledTableCell align="center">Hour Target</StyledTableCell>
                        <StyledTableCell align="center">H1</StyledTableCell>
                        <StyledTableCell align="center">H2</StyledTableCell>
                        <StyledTableCell align="center">H3</StyledTableCell>
                        <StyledTableCell align="center">H4</StyledTableCell>
                        <StyledTableCell align="center">H5</StyledTableCell>
                        <StyledTableCell align="center">H6</StyledTableCell>
                        <StyledTableCell align="center">H7</StyledTableCell>
                        <StyledTableCell align="center">H8</StyledTableCell>
                        <StyledTableCell align="center">H9</StyledTableCell>
                        <StyledTableCell align="center">H10</StyledTableCell>
                        <StyledTableCell align="center">H11</StyledTableCell>
                        <StyledTableCell align="center">H12</StyledTableCell>
                        <StyledTableCell align="center">Expected</StyledTableCell>
                        <StyledTableCell align="center">Actual</StyledTableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {(rowsPerPage > 0
                        ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : filteredData
                      ).map((enq, index) => (
                        <TableRow key={index} hover>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.sno}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.DailyProddate}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.Line_Name}
                          </TableCell>
                          {/* <TableCell
                              align="left"
                              padding="normal"
                              sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                            >
                              {enq.StyleDescription}
                            </TableCell> */}
                          <TableCell
                            align="left"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.OperationName}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.OperatorName}
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.Targeted}
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H1 === 0 ? '' : enq.H1} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H1 === 0 ? '' : `(${Math.round((enq.H1 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H2 === 0 ? '' : enq.H2} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H2 === 0 ? '' : `(${Math.round((enq.H2 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H3 === 0 ? '' : enq.H3} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H3 === 0 ? '' : `(${Math.round((enq.H3 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H4 === 0 ? '' : enq.H4} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H4 === 0 ? '' : `(${Math.round((enq.H4 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H5 === 0 ? '' : enq.H5} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H5 === 0 ? '' : `(${Math.round((enq.H5 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H6 === 0 ? '' : enq.H6} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H6 === 0 ? '' : `(${Math.round((enq.H6 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H7 === 0 ? '' : enq.H7} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H7 === 0 ? '' : `(${Math.round((enq.H7 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H8 === 0 ? '' : enq.H8} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H8 === 0 ? '' : `(${Math.round((enq.H8 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H9 === 0 ? '' : enq.H9} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H9 === 0 ? '' : `(${Math.round((enq.H9 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H10 === 0 ? '' : enq.H10} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H10 === 0 ? '' : `(${Math.round((enq.H10 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H11 === 0 ? '' : enq.H11} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H11 === 0 ? '' : `(${Math.round((enq.H11 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.H12 === 0 ? '' : enq.H12} </span>
                            <span style={{ color: '#53a0c7', fontSize: 'smaller' }}>
                              {enq.H12 === 0 ? '' : `(${Math.round((enq.H12 / enq.Targeted) * 100)}%)`}
                            </span>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            {enq.EXPECTED}
                          </TableCell>

                          <TableCell
                            align="center"
                            padding="normal"
                            sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}
                          >
                            <span style={{ fontWeight: 600 }}>{enq.TOTAL} </span><span style={{ color: '#4eb72d', fontSize: 'smaller' }}>({enq.ACTUAL}%)</span>
                          </TableCell>

                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}

            
            {/* pagination */}
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage} // Use the calculated currentPage value
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0); // Reset the page when rowsPerPage changes
              }}
              mt={2}
            />
          </>
        </Collapse>
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {/* show Hourwise Efficieny details */}
      <Dialog open={efficiencyDetailsOpen} onClose={handleEfficiencyDetailsClose} maxWidth="lg" fullScreen>
        <DialogTitle>Hourwise Efficiency</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <Divider />
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                my={1}
              >
                <Typography variant="subtitle2" color="#219C90">Style : {styleSelected.StyleDescription}</Typography>
                <Typography variant="subtitle2" color="#219C90">{`${moment(fromDate).format("DD/MM/YYYY")} - ${moment(toDate).format("DD/MM/YYYY")}`}</Typography>
              </Stack>
            </Grid>
          </Grid>
          <TableContainer sx={{ maxHeight: '100%' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">S.No</StyledTableCell>
                  <StyledTableCell align="center">Date</StyledTableCell>
                  <StyledTableCell align="left">Factory</StyledTableCell>
                  <StyledTableCell align="center">Line</StyledTableCell>
                  <StyledTableCell align="center">H1</StyledTableCell>
                  <StyledTableCell align="center">H2</StyledTableCell>
                  <StyledTableCell align="center">H3</StyledTableCell>
                  <StyledTableCell align="center">H4</StyledTableCell>
                  <StyledTableCell align="center">H5</StyledTableCell>
                  <StyledTableCell align="center">H6</StyledTableCell>
                  <StyledTableCell align="center">H7</StyledTableCell>
                  <StyledTableCell align="center">H8</StyledTableCell>
                  <StyledTableCell align="center">H9</StyledTableCell>
                  <StyledTableCell align="center">H10</StyledTableCell>
                  <StyledTableCell align="center">H11</StyledTableCell>
                  <StyledTableCell align="center">H12</StyledTableCell>
                  <StyledTableCell align="center">Total</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {efficiencyData.map((obj, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{obj.DailyProddate}</TableCell>
                    <TableCell align="left">{obj.Unit_Name}</TableCell>
                    <TableCell align="center">{obj.Line_Name}</TableCell>
                    <TableCell align="center">{obj.H1Eff}%</TableCell>
                    <TableCell align="center">{obj.H2Eff}%</TableCell>
                    <TableCell align="center">{obj.H3Eff}%</TableCell>
                    <TableCell align="center">{obj.H4Eff}%</TableCell>
                    <TableCell align="center">{obj.H5Eff}%</TableCell>
                    <TableCell align="center">{obj.H6Eff}%</TableCell>
                    <TableCell align="center">{obj.H7Eff}%</TableCell>
                    <TableCell align="center">{obj.H8Eff}%</TableCell>
                    <TableCell align="center">{obj.H9Eff}%</TableCell>
                    <TableCell align="center">{obj.H10Eff}%</TableCell>
                    <TableCell align="center">{obj.H11Eff}%</TableCell>
                    <TableCell align="center">{obj.H12Eff}%</TableCell>
                    <TableCell align="center">{obj.TotalEff}%</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEfficiencyDetailsClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DailyProductionHourlyReport;
